export interface NepalProvince {
    name: string;
    districts: string[];
}

export const NEPAL_PROVINCES: NepalProvince[] = [
    {
        name: 'Koshi Province',
        districts: [
            'Bhojpur', 'Dhankuta', 'Ilam', 'Jhapa', 'Khotang', 'Morang',
            'Okhaldhunga', 'Panchthar', 'Sankhuwasabha', 'Solukhumbu',
            'Sunsari', 'Taplejung', 'Terhathum', 'Udayapur',
        ],
    },
    {
        name: 'Madhesh Province',
        districts: [
            'Bara', 'Dhanusha', 'Mahottari', 'Parsa', 'Rautahat',
            'Saptari', 'Sarlahi', 'Siraha',
        ],
    },
    {
        name: 'Bagmati Province',
        districts: [
            'Bhaktapur', 'Chitwan', 'Dhading', 'Dolakha', 'Kathmandu',
            'Kavrepalanchok', 'Lalitpur', 'Makwanpur', 'Nuwakot',
            'Ramechhap', 'Rasuwa', 'Sindhuli', 'Sindhupalchok',
        ],
    },
    {
        name: 'Gandaki Province',
        districts: [
            'Baglung', 'Gorkha', 'Kaski', 'Lamjung', 'Manang', 'Mustang',
            'Myagdi', 'Nawalpur', 'Parbat', 'Syangja', 'Tanahun',
        ],
    },
    {
        name: 'Lumbini Province',
        districts: [
            'Arghakhanchi', 'Banke', 'Bardiya', 'Dang', 'Eastern Rukum',
            'Gulmi', 'Kapilvastu', 'Nawalparasi West', 'Palpa', 'Pyuthan',
            'Rolpa', 'Rupandehi',
        ],
    },
    {
        name: 'Karnali Province',
        districts: [
            'Dailekh', 'Dolpa', 'Humla', 'Jajarkot', 'Jumla', 'Kalikot',
            'Mugu', 'Salyan', 'Surkhet', 'Western Rukum',
        ],
    },
    {
        name: 'Sudurpashchim Province',
        districts: [
            'Achham', 'Baitadi', 'Bajhang', 'Bajura', 'Dadeldhura',
            'Darchula', 'Doti', 'Kailali', 'Kanchanpur',
        ],
    },
];
